/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_MethodInputs */

const vi_cashflow_method = /** @type {(inputs: Cashflow_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương thức`)
};

/**

* @param {Cashflow_MethodInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_method = /** @type {((inputs?: Cashflow_MethodInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_MethodInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_method(inputs)
});